var _ = require('lodash');

var surveyUtils = (function() {

    var _getSurveyId = function(history, index) {
        return history.index[index];
    };

    var _getSequenceLength = function(surveys, surveyId) {
        return surveys[surveyId].sequence.length;
    };

    var _getSequenceId = function(surveys, surveyId, index) {
        return surveys[surveyId] ? surveys[surveyId].sequence[index] : '';
    };

    var _getCurrentSequence = function(sequences, sequenceId) {
        return sequences[sequenceId];
    };

    var _getCurrentField = function(fields, fieldName) {
        return fields[fieldName] || {};
    };

    var _getFieldNavigation = function(fields, fieldName) {
        return fields[fieldName].navigation;
    };

    var _getNextSurveyIndex = function(history) {
        return history.currentSurveyIndex + 1;
    };

    var _getSurveysLength = function(surveys) {
        return surveys.length;
    };

    var _getPriorResponse = function(field, submissions) {
        const fieldName = field.populateWithChoicesFrom || field.enableOnlyChoicesFrom;
        const { filterByTag = ''} = field;

        let fieldNameArray = [];
        if ( typeof fieldName === 'string' ) {
            fieldNameArray.push(fieldName);
        } else {
            fieldNameArray = fieldName;
        }

        let combinedSubmissions = [];
        _.forEach(fieldNameArray, (field) => {
            var priorSubmission = submissions.filter(function(submission) {
                return submission[1] === field;
            })[0];

            if (priorSubmission) {
                combinedSubmissions = _.concat(combinedSubmissions, priorSubmission[2]);    
            }
        });

        // Filter out ignored fields (tag contains 'x_')
        combinedSubmissions = _.reject(combinedSubmissions, (response) => {
            if (response.tag) {
                return _.includes(response.tag, 'x_');   
            }
        });

        // Filter out filterByTag
        if (filterByTag) {
            combinedSubmissions = _.filter(combinedSubmissions, (response) => {
                if (response.tag) {
                    return _.includes(response.tag, filterByTag);   
                }
            });          
        }

        return (combinedSubmissions) || [];
    };

    var _filterChoices = function(field, responses) {
        const { carryForwardFrom = [], carryForwardTags = [] } = field || {};

        // Use correct field for x-axis data (rows for matrix, choices for all else)
        const fieldData = (field.type === 'matrix') ? 'rows' : 'choices';

        if(carryForwardFrom.length > 0) {
            // Filter responses list by carryForwardFrom array
            const filteredResponses = _(responses)
                .keyBy(1)
                .at(carryForwardFrom)
                .value();

            // Extract tags from previous responses
            if (Object.keys(filteredResponses).length > 0) {
                // Flatten responses in case of multiple questions
                let carryForwardResponses = _.flatten(_.map(filteredResponses, arr => arr && arr[2])) || [];

                // Filter out ignored fields (tag contains 'x_')
                carryForwardResponses = _.reject(carryForwardResponses, (response) => {
                    if (response && response.tag) {
                        return _.includes(response.tag, 'x_');   
                    }
                });

                // Filter current field by carryForwardTags
                if (carryForwardTags.length > 0) {
                    carryForwardResponses = _.filter(carryForwardResponses, (response) => {
                        if (response && response.tag) {
                            console.log(response.tag);
                            console.log(carryForwardTags);
                            return _.trim(_.includes(response.tag, carryForwardTags), '_' + carryForwardTags);   
                        }
                    });                    
                }
                
                // Remove appended responses from matrix questions


                // Map to a tags array
                const filteredTags = _.map(carryForwardResponses, 'tag') || [];

                // Append required tags
                _.forEach(field[fieldData], (row) => {
                    if (row && row.required) {
                        filteredTags.push(row.tag);
                    }
                })

                field[fieldData] = _(field[fieldData])
                .keyBy('tag')
                .at(filteredTags)
                .value();
            }
        }

        return field;
    }

    return {
        getSurveyId: _getSurveyId,
        getSequenceLength: _getSequenceLength,
        getSequenceId: _getSequenceId,
        getCurrentSequence: _getCurrentSequence,
        getCurrentField: _getCurrentField,
        getFieldNavigation: _getFieldNavigation,
        getNextSurveyIndex: _getNextSurveyIndex,
        getPriorResponse: _getPriorResponse,
        getSurveysLength: _getSurveysLength,
        filterChoices: _filterChoices
    };

})();

module.exports = surveyUtils;



// WEBPACK FOOTER //
// ./src/common/modules/survey/utils.js